import BaseValidator from 'services/validations/base-validator';
import Const from 'const';

class MaxStackAndCombinationPlayersQuantityValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking, sportConfig} = this.dependencies;
        const items = stacking.getItems();
        const QBPositionQuantityInLineup = 1;
        const playersInLineup = sportConfig.getConfigProp('playersInTeam', 0);

        items.forEach((item) => {
            if (item.isSecondaryStackTypeNone()) {
                return;
            }

            let minStackPlayersQuantity = QBPositionQuantityInLineup + item.getFirstTeamAtLeastPlayers();
            if (item.isGameStackType()) {
                minStackPlayersQuantity += item.getSecondTeamAtLeastPlayers();
            }

            // At least 2 players have to be pushed to lineup per each secondary stack type.
            let minCombinationPlayersQuantity = Const.CORRELATION_SECONDARY_STACK_COMBINATION_PLAYERS_QUANTITY;
            if (item.isSecondaryStackTypeDouble()) {
                minCombinationPlayersQuantity += Const.CORRELATION_SECONDARY_STACK_COMBINATION_PLAYERS_QUANTITY;
            }

            if (playersInLineup - minCombinationPlayersQuantity < minStackPlayersQuantity) {
                this.addError('Quantity of possible secondary stack combinations is exceeded.');
            }
        });
    }
}

export default MaxStackAndCombinationPlayersQuantityValidator;
